module.exports = __webpack_public_path__ + "img/fr.fc403897.png";